import { render, staticRenderFns } from "./AboutTab.vue?vue&type=template&id=6851a41a"
import script from "./AboutTab.vue?vue&type=script&lang=js"
export * from "./AboutTab.vue?vue&type=script&lang=js"
import style0 from "./AboutTab.vue?vue&type=style&index=0&id=6851a41a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports